const CANONICAL_APP_HOSTNAME = 'app.orgamax.de'

export const AI_WIDGET_EXTERNAL_LINK_PARAMS = {
  utm_source: 'webapp',
  utm_medium: 'agentmax',
} as const

export const withAiWidgetExternalTracking = (href: string): string => {
  const url = new URL(href)
  Object.entries(AI_WIDGET_EXTERNAL_LINK_PARAMS).forEach(([name, value]) => url.searchParams.set(name, value))
  return url.toString()
}

export type AiWidgetLinkResolution =
  | { kind: 'internal', target: string }
  | { kind: 'external', target: string }
  | { kind: 'telephone', target: string }
  | { kind: 'email', target: string }
  | { kind: 'ignored' }

const SIMPLE_EMAIL = /^[A-Za-z0-9](?:[A-Za-z0-9.!$%'+_=-]*[A-Za-z0-9])?@[A-Za-z0-9](?:[A-Za-z0-9-]*[A-Za-z0-9])?(?:\.[A-Za-z0-9](?:[A-Za-z0-9-]*[A-Za-z0-9])?)+$/

export const resolveAiWidgetLink = (href: string, currentHref: string): AiWidgetLinkResolution => {
  const candidate = href.trim()
  if (!candidate) return { kind: 'ignored' }

  try {
    const currentUrl = new URL(currentHref)
    const url = new URL(candidate, currentUrl)

    if (url.protocol === 'tel:') {
      return { kind: 'telephone', target: candidate }
    }

    if (url.protocol === 'mailto:') {
      const address = candidate.slice('mailto:'.length)
      return candidate.toLowerCase().startsWith('mailto:')
        && SIMPLE_EMAIL.test(address)
        && !address.includes('..')
        && !/[\r\n?#]/.test(address)
        ? { kind: 'email', target: `mailto:${address}` }
        : { kind: 'ignored' }
    }

    if (url.protocol !== 'http:' && url.protocol !== 'https:') {
      return { kind: 'ignored' }
    }

    if (url.origin === currentUrl.origin || url.hostname === CANONICAL_APP_HOSTNAME) {
      return { kind: 'internal', target: `${url.pathname}${url.search}${url.hash}` }
    }

    return { kind: 'external', target: url.toString() }
  } catch {
    return { kind: 'ignored' }
  }
}
